interface MedicalDirectorIdentity {
  roleName?: string;
  groupName?: string;
  groups?: Array<{ id: string; name: string }>;
}

const MEDICAL_DIRECTOR_NAMES = new Set([
  "medical director",
  "medical directors",
]);

function isMedicalDirectorName(name: string | undefined): boolean {
  return MEDICAL_DIRECTOR_NAMES.has(name?.trim().toLowerCase() ?? "");
}

export function isMedicalDirector(
  identity: MedicalDirectorIdentity | null | undefined
): boolean {
  if (!identity) return false;
  return (
    isMedicalDirectorName(identity.roleName) ||
    isMedicalDirectorName(identity.groupName) ||
    identity.groups?.some((group) => isMedicalDirectorName(group.name)) === true
  );
}
